
export default {
  name: 'CheckoutStepIndicator',
  props: {
    value: {
      type: Number,
      default: 1
    },
    steps: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      activeStep: this.value
    }
  },
  computed: {
    currentStep () {
      return this.steps[this.activeStep]
    }
  },
  watch: {
    value (newValue) {
      this.activeStep = newValue
    }
  },
  methods: {
    canGoBack (step, index) {
      if (
        !this.currentStep.movement ||
        !this.currentStep.movement.backwards ||
        !this.currentStep.movement.backwards.includes(index)
      ) {
        return null
      }

      return {
        is: 'nuxt-link',
        to: { name: step.page }
      }
    }
  }
}
